<template>
  <div v-if="!showDetail" class="d-flex flex-wrap w-100">
    <h2 class="w-100 mb-3"> تاریخچه براساس کد ملی</h2>
    <div @click="getDetail(item)" v-for="item in props.data" :key="item.id" class="col-box">
      <h6>{{ item.fullname }}</h6>
      <p>{{ item.description }}</p>
      <p>{{ item.create_user }}</p>
      <p>{{ item.cartable_title }}</p>
      <p>{{ item.type }}</p>
      <p>{{ item.meli_cod }}</p>
      <span>{{ toJalali(item.created_at) }}</span>
    </div>
  </div>

  <div v-if="showDetail" class="detail-box">
    <div class="btn-back w-100 d-flex items-center ">
      <h3 class="ml-auto">ثبت شده توسط : {{taskData.create_user}}</h3>
      <button type="button" class="d-flex items-center" @click="showDetail = false">
        بازگشت
        <i class="fa-regular fa-angle-left mr-2"></i>
      </button>


    </div>
    <div class="w-100 d-flex flex-wrap mt-3">
      <div class="input">
        <label>کد رهگیری</label>
        <input disabled v-model="taskData.code" type="text"/>
      </div>
      <div class="input">
        <label>نام و نام خانوادگی</label>
        <input disabled v-model="taskData.fullname" type="text"/>
      </div>

      <div class="input">
        <label>استان</label>
        <input disabled v-model="taskData.province" type="text"/>
      </div>
      <div class="input">
        <label>شهر</label>
        <input disabled v-model="taskData.city" type="text"/>
      </div>
      <div class="input">
        <label>وضعیت</label>
        <input disabled v-model="taskData.status" type="text"/>
      </div>
      <div class="input">
        <label>کدملی</label>
        <input disabled v-model="taskData.meli_code" type="text"/>
      </div>
      <div class="input">
        <label>شماره موبایل</label>
        <input disabled v-model="taskData.mobile" type="text"/>
      </div>
      <div class="input">
        <label>شماره ثابت</label>
        <input disabled v-model="taskData.home" type="text"/>
      </div>
      <div class="input">
        <label>گروه درخواست</label>
        <input disabled v-model="taskData.type" type="text"/>
      </div>
       <div class="input w-100">
        <label>توضیحات</label>
        <textarea style="height: 100px" disabled v-model="taskData.description" type="text"></textarea>
      </div>
      <section class="history-activities w-100" dir="rtl">

        <RequestActivityTimeline :answers="taskData.answers || []" :notes="taskData.notes || []" />
      </section>
    </div>

  </div>

  <!--  <div v-if="props.data?.length" class="table-section">
      <table class="table w-100 table-striped">
        <thead>
        <tr>
          <th scope="col">شناسه</th>
          <th scope="col">تاریخ</th>
          <th scope="col">کاربر</th>
          <th scope="col">گروه درخواست</th>
          <th scope="col">استان</th>
          <th scope="col">کدپیگیری</th>
          <th scope="col">کدملی</th>
          <th scope="col">موبایل</th>
          <th scope="col">توضیحات مودی</th>
          <th scope="col">پاسخ کارشناس</th>
          <th scope="col">درگاه</th>
        </tr>
        </thead>
        <tbody>

        <tr v-for="item in props.data" :key="item.id">
          <th>{{ item.id }}</th>
          <td>{{ toJalali(item.created_at)}}</td>
          <td>{{item.fullname }}</td>
          <td>{{item.type }}</td>
          <td>{{item.province }}</td>
          <td>{{item.code }}</td>
          <td>{{item.meli_code}}</td>
          <td>{{item.mobile }}</td>
          <td>{{item.description }}</td>
          <td><div class="box-answer" v-for="x in item.answers">{{x.answer}}</div></td>
          <td>{{item.cartable_title }}</td>


        </tr>

        </tbody>
      </table>
    </div>-->
</template>

<script setup>
import {onMounted, ref} from "vue";
import RequestActivityTimeline from "@/components/RequestActivityTimeline.vue";

const showDetail = ref(false)
const taskData = ref('')
const getDetail = (item) => {
  console.log(item)
  taskData.value = item
  showDetail.value = true
}
const props = defineProps({
  data: {
    type: Array,
    required: false,
  },

})

onMounted(() => {
  console.log(props.data)
})
const toJalali = (value) => {
  try {
    return new Intl.DateTimeFormat('fa-IR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    }).format(new Date(value))
  } catch {
    return value
  }
}
</script>

<style lang="scss" scoped>
.history-activities {
  min-width: 0;
  padding: 10px;

  &__title {
    margin: 12px 0 16px;
    color: #30394b;
    font-size: 18px;
    font-weight: 700;
    text-align: right;
  }

  :deep(.activity-timeline) { margin: 0; }
}
.date{
  direction: ltr;
}
.col-box {
  width: calc(20% - 20px);
  margin: 10px;
  border: 1px solid #458fff;
  border-radius: 5px;
  transition: all ease .4s;
  padding: 10px;
  cursor: pointer;

  &:hover {
    background: rgba(69, 143, 255, 0.13);
  }

  span {
    font-size: 10px;
    margin-right: auto;
    width: 100%;
    text-align: left;
    display: block;
    margin-top: 10px;
    direction: ltr;
  }

  h6 {
    margin-bottom: 5px;
    display: block;
    width: 100%;
    color: #458fff;

  }

  p {
    line-break: anywhere;
    font-size: 12px;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

}

.detail-box {
  width: 100%;

  .input {
    width: 33.333%;
    padding: 10px;
    position: relative;

    .loading {
      position: absolute;
      left: 15px;
      bottom: 26px;
    }

    > label {
      width: 100%;
      font-size: 14px;
      color: #3D444F;
      padding: 10px;
    }

    > input, > textarea {
      width: 100%;
      padding: 10px;
      border-radius: 99px;
      border: 1px solid #D7DBE0;
      height: 48px;

      &:disabled {
        background: rgba(238, 238, 238, 0.62);
      }
    }

    &.field-box {
      label em {
        color: #f00;
      }

      .check-div, .radio-div {
        width: 100%;
        margin-bottom: 5px;
        display: flex;
        flex-wrap: wrap;

        label {
          width: 100%;
          font-size: 14px;
          color: #3D444F;
          padding: 10px;
        }

        > div {
          display: flex;
          align-items: center;
          padding: 5px;

          label {
            margin-bottom: 0;
            padding: 0 4px;
          }
        }
      }

    }
  }
}

td {
  padding: 5px;
  font-size: 12px;
}

.box-answer {
  max-width: 300px;
  padding: 5px;
  line-break: anywhere;
  margin: 5px;
}
</style>
